define('SchemaOrg.BaseModule', [
    'jQuery',
    'underscore'
], function SchemaOrgBaseModule(
    jQuery,
    _
) {
    'use strict';
    
    return {
        init: function initialize(options) {
            _.extend(this, options);
            this.addToPusher();
        },
        moduleType: 'jsonLD',
        addToPusher: function render() {
            try {
                this.pusher.modulesToPush[this.moduleType] = JSON.stringify(this.createJSONLD());
                this.pusher.pushData();
            } catch (e) {
                // eslint-disable-next-line
                console.log('Schema Error:', e);
                return this;
            }
            return this;
        },
        createJSONLD: function createJSONLD() {
            return {};
        }
    };
});
